import React from 'react'
import cn from 'classnames'
import { format } from 'date-fns'
import { ICycleCount, ICycleCountItem } from '../../types/cycle-counts'

interface ICycleCountStatusProps {
  cycleCount: ICycleCount
}

const TABLE_WIDTHS = {
  STATUS: '-fix150',
  COUNTED_BY: '-g8',
  COUNTED_DATE: '-fix150',
  APPROVED_BY: '-g8',
  APPROVED: '-fix150',
  REJECTED: '-fix150',
  TOTAL: '-fix150',
}

const CycleCountStatus: React.FC<ICycleCountStatusProps> = ({ cycleCount }) => {
  if (!cycleCount) return null
  if (!cycleCount.cycleCountItems) return null

  const approved = (cycleCount.cycleCountItems ?? [])
    .filter((item: ICycleCountItem) => item.status === 'approved')
    .reduce((acc: number, item: ICycleCountItem) => acc + item.countedAmount, 0)
  const rejected = (cycleCount.cycleCountItems ?? [])
    .filter((item: ICycleCountItem) => item.status === 'rejected')
    .reduce((acc: number, item: ICycleCountItem) => acc + item.countedAmount, 0)
  const total = (cycleCount.cycleCountItems ?? []).reduce(
    (acc: number, item: ICycleCountItem) => acc + item.countedAmount,
    0,
  )

  return (
    <div className="cycle-count_status">
      <div className="table">
        <div className="table_head-tr" style={{ marginBottom: 0 }}>
          <div className={`table_td table_title ${TABLE_WIDTHS.STATUS}`}>
            Status
          </div>
          <div className={`table_td table_title ${TABLE_WIDTHS.COUNTED_DATE}`}>
            Counted Date
          </div>
          <div className={`table_td table_title ${TABLE_WIDTHS.COUNTED_BY}`}>
            Counted By
          </div>
          <div className={`table_td table_title ${TABLE_WIDTHS.APPROVED_BY}`}>
            Approved By
          </div>
          <div className={`table_td table_title ${TABLE_WIDTHS.APPROVED}`}>
            Approved
          </div>
          <div className={`table_td table_title ${TABLE_WIDTHS.REJECTED}`}>
            Rejected
          </div>
          <div className={`table_td table_title ${TABLE_WIDTHS.TOTAL}`}>
            Total
          </div>
        </div>
        <div className="table_tr" style={{ backgroundColor: 'transparent' }}>
          <div className={`table_td ${TABLE_WIDTHS.STATUS}`}>
            <div
              style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
              className={cn('user-status_badge', {
                active: cycleCount.status === 'completed',
                inactive: cycleCount.status === 'rejected',
              })}
            >
              {cycleCount.status}
            </div>
          </div>
          <div className={`table_td ${TABLE_WIDTHS.COUNTED_DATE}`}>
            {format(new Date(cycleCount.countedAt), 'MMM D, YYYY')}
          </div>
          <div className={`table_td ${TABLE_WIDTHS.COUNTED_BY}`}>
            {cycleCount.countedBy?.name}
          </div>
          <div className={`table_td ${TABLE_WIDTHS.APPROVED_BY}`}>
            {cycleCount?.completedBy?.name || '-'}
          </div>
          <div className={`table_td ${TABLE_WIDTHS.APPROVED}`}>{approved}</div>
          <div className={`table_td ${TABLE_WIDTHS.REJECTED}`}>{rejected}</div>
          <div className={`table_td ${TABLE_WIDTHS.TOTAL}`}>{total || 0}</div>
        </div>
      </div>
    </div>
  )
}

export default CycleCountStatus
